import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { isManager } from '@plone/volto/helpers/User/User';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

import { ServiceGridListingItemTemplate } from '../../Blocks/Listing/ServiceGridListingItemTemplate';

const ServiceView = (props) => {
  const user = useSelector((state) => state.users.user);
  useEffect(() => {
    if (!isManager(user)) {
      window.location.href = flattenToAppURL(props.content.parent?.['@id']);
    }
  }, [user, props.content.parent]);

  return (
    <div
      className="block search ui grid"
      style={{ maxWidth: '80%', marginLeft: '10%' }}
    >
      {isManager(user) && (
        <p>
          <FormattedMessage
            id="This view will be redirected for non manager users:"
            defaultMessage="This view will be redirected for non manager users:"
          />
          <UniversalLink item={props.content.parent}>
            {props.content.parent.title}
          </UniversalLink>
        </p>
      )}
      <div className="row">
        <div className="nine wide computer twelve wide mobile eight wide tablet column">
          <div className="items">
            <div className="listing-item">
              <ServiceGridListingItemTemplate
                item={{ ...props.content, image_field: 'image' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceView;
